<template>
  <!-- Navigation -->
  <nav :class="{ active: isActive }">
    <div class="w-100%">
      <template v-if="!isMobile">
        <!-- web -->
        <div class="flex justify-between items-center h-16">
          <!-- Logo -->
          <div class="flex items-center space-x-12">
            <router-link
              to="/home"
              class="text-xl lg:text-2xl xl:mr-[4.4rem] lg:mr-[2.4rem] md:mr-[1.12rem] font-bold text-gray-900"
            >
              <img class="w-[11.63rem]" :src="logo" alt="" />
            </router-link>

            <router-link
              to="/home"
              class="text-gray-600 hover:text-gray-900 transition-colors font-medium"
              active-class="color-[#9038FF]"
              exact-active-class="color-[#9038FF]"
            >
              {{ t("header.text1") }}
            </router-link>
            <router-link
              to="/price"
              class="text-gray-600 hover:text-gray-900 transition-colors font-medium"
              active-class="color-[#9038FF]"
              exact-active-class="color-[#9038FF]"
            >
              {{ t("header.text2") }}
            </router-link>
            <router-link
              to="/about"
              class="text-gray-600 hover:text-gray-900 transition-colors font-medium"
              active-class="color-[#9038FF]"
              exact-active-class="color-[#9038FF]"
            >
              {{ t("header.text3") }}
            </router-link>
            <router-link
              to="/case"
              class="text-gray-600 hover:text-gray-900 transition-colors font-medium"
              active-class="color-[#9038FF]"
              exact-active-class="color-[#9038FF]"
            >
              {{ t("header.text8") }}
            </router-link>
            <span
              class="text-gray-600 hover:text-gray-900 transition-colors font-medium cursor-pointer"
              @click="hendleOpen(helpDocUrl)"
            >
              {{ t("header.text4") }}
            </span>
          </div>

          <!-- Navigation Links -->
          <div class="flex items-center space-x-6">
            <el-dropdown class="cursor-pointer" popper-class="header-dropdown-color">
              <span
                class="el-dropdown-link outline-none flex items-center justify-between"
              >
                <img
                  class="w-[0.8rem] h-[0.8rem] mr-[0.19rem]"
                  src="@/assets/images/influenbase-language.png"
                  alt=""
                />

                <span> {{ currentLocale === "zh" ? "简体中文" : "English" }}</span>

                <el-icon class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="handleChangeLanguage('zh')">
                    简体中文
                  </el-dropdown-item>
                  <el-dropdown-item @click="handleChangeLanguage('en')">
                    English
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <button
              @click="hendleOpen(extensionUrl)"
              class="pl-[20px] pr-[20px] h-[2.25rem] hover:opacity-100 opacity-70 transition-all duration-300 bg-[#9038FF] rounded-[1.25rem] text-white text-size-[0.88rem]"
            >
              {{ $t("header.text7") }}
            </button>
          </div>
        </div>
      </template>
      <!-- h5 -->
      <template v-else>
        <div class="mobile-header flex justify-between items-center">
          <div class="flex items-center left rounded-[75px]">
            <img class="w-[200px]" :src="logo" alt="" />
          </div>
          <div class="right flex items-center">
            <el-dropdown popper-class="header-dropdown" class="cursor-pointer">
              <span
                class="el-dropdown-link outline-none flex items-center justify-between"
              >
                <img
                  class="w-[24px] h-[24px] mr-[12px]"
                  src="@/assets/images/influenbase-language.png"
                  alt=""
                />

                <span class="text-[24px] c-[#34322D]">
                  {{ currentLocale === "zh" ? "简体中文" : "English" }}
                </span>

                <el-icon size="16" class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="handleChangeLanguage('zh')">
                    <span class="text-[24px]">简体中文 </span>
                  </el-dropdown-item>
                  <el-dropdown-item @click="handleChangeLanguage('en')">
                    <span class="text-[24px]">English</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <img
              class="w-[30px] h-[30px] ml-59px"
              src="@/assets/images/influenbase-header-menu.png"
              alt=""
              @click.stop="showMobileHeader = true"
            />
          </div>
        </div>
      </template>
    </div>

    <div
      class="mobile-menu-box"
      :class="{ show: showMobileHeader }"
      @click="showMobileHeader = false"
    >
      <div @click.stop="" :class="{ open: showMobileHeader }" class="mobile-menu">
        <div class="menu-header">
          <div class="left">
            <img class="w-[200px]" :src="logo" alt="" />
          </div>
          <div class="right">
            <el-dropdown popper-class="header-dropdown" class="cursor-pointer">
              <span
                class="el-dropdown-link outline-none flex items-center justify-between"
              >
                <img
                  class="w-[24px] h-[24px] mr-[12px]"
                  src="@/assets/images/influenbase-language.png"
                  alt=""
                />

                <span class="text-[24px] c-[#34322D]">
                  {{ currentLocale === "zh" ? "简体中文" : "English" }}
                </span>

                <el-icon size="16" class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    class="text-[20px]"
                    @click="handleChangeLanguage('zh')"
                  >
                    <span class="text-[24px]">简体中文 </span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="text-[20px]"
                    @click="handleChangeLanguage('en')"
                  >
                    <span class="text-[24px]">English </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <img
              class="w-[30px] h-[30px] ml-59px"
              src="@/assets/images/influenbase-header-menu.png"
              alt=""
              @click.stop="showMobileHeader = false"
            />
          </div>
        </div>
        <ul>
          <li
            :class="{ isActive: $route.path === '/mobile/home' }"
            @click="handleGoto('/mobile/home')"
          >
            {{ t("header.text1") }}
          </li>
          <li
            :class="{ isActive: $route.path === '/mobile/price' }"
            @click="handleGoto('/mobile/price')"
          >
            {{ t("header.text2") }}
          </li>
          <li
            :class="{ isActive: $route.path === '/mobile/about' }"
            @click="handleGoto('/mobile/about')"
          >
            {{ t("header.text3") }}
          </li>
          <li
            :class="{ isActive: $route.path === '/mobile/case' }"
            @click="handleGoto('/mobile/case')"
          >
            {{ t("header.text8") }}
          </li>
          <li @click="hendleOpen(helpDocUrl)">
            {{ t("header.text4") }}
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref, computed, onUnmounted, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { ArrowDown } from "@element-plus/icons-vue";
import { useGetLanguage } from "@/hooks/useGetLanguage";
import { useDevice } from "@/hooks/useDevice";
import router from "@/router";

const { t, locale } = useI18n();
const currentLocale = computed(() => locale.value);
const handleChangeLanguage = (type: string) => {
  if (locale.value === type) return;
  let languaguObj: any = {
    zh:
      window.location.origin +
      window.location.pathname.replace("en/", "") +
      window.location.hash,
    en: window.location.origin + window.location.pathname + "en/" + window.location.hash,
  };
  window.location.href = languaguObj[type];
};

const setTitle = () => {
  document.title = t("system.text1");
};
setTitle();

const isActive = ref(false);
function setActive() {
  if (window.scrollY > 10) {
    isActive.value = true;
  } else {
    isActive.value = false;
  }
}

onMounted(() => {
  window.addEventListener("scroll", setActive);
});

onUnmounted(() => {
  window.removeEventListener("scroll", setActive);
});

const { helpDocUrl, logo, extensionUrl } = useGetLanguage();
function hendleOpen(url: string) {
  window.open(url);
  showMobileHeader.value = false;
}

/********************************** 移动端头部信息 start ************************************/
const { isMobile } = useDevice();
const showMobileHeader = ref(false);

function handleGoto(path: string) {
  router.push({
    path,
  });
  showMobileHeader.value = false;
}

/********************************** 移动端头部信息 end ************************************/
</script>

<style scoped lang="scss">
nav {
  width: 90vw;
  margin-top: 20px;
  margin-left: 5vw;
  height: 80px;
  border-radius: 44px;
  transition: all 0.3s;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 900;
  display: flex;
  align-items: center;
  padding: 0 40px 0 20px;
}

.active {
  background: #f7f0fe;
}

.isMobile {
  width: calc(100vw - 88px);
  padding: 0;
  margin: 54px auto 0 auto;
  left: 44px;
  padding: 0 30px 0 16px;
}

.mobile-menu-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.6);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

  &.show {
    opacity: 1;
    visibility: visible;
  }

  .mobile-menu {
    width: calc(100vw);
    height: 0;
    background: #fff;
    position: absolute;
    z-index: 2000;
    color: #fff;
    padding: 0 60px;
    overflow: hidden;
    padding-top: 50px;
    transition: height 0.3s ease-in-out;
    .menu-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 88px;
      > div {
        display: flex;
        align-items: center;
      }

      .left {
        padding: 9px 37px;
        border-radius: 75px 75px 75px 75px;
        background-color: rgba($color: #bdbffd, $alpha: 0.17);
        font-size: 0;
        height: 48px;
        img {
          display: block;
          width: 126px;
          height: auto;
          object-fit: contain;
          max-height: 70px;
        }
      }
    }
    ul {
      color: red;
      width: 100%;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #858481;

      li {
        padding-bottom: 30px;
        border-bottom: 1px #f4f4ff solid;
        padding-top: 30px;
      }

      .isActive {
        font-weight: 600;
        color: #9038ff;
      }
    }

    &.open {
      height: 630px;
    }
  }
}

.mobile-header {
  .left {
    font-size: 0;
    background-color: rgba($color: #bdbffd, $alpha: 0.17);
    height: 48px;
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: 126px;
      height: auto;
      object-fit: contain;
      max-height: 70px;
    }
  }
}
</style>
